export const WfConstTracker = {
	PATIENT: 'patient',
	CLINICAL: 'clinical',
	TEST: 'test',
	RISPACS: 'rispacs',
	SURGERY: 'surgery',
	SAMPLE: 'sample',
	CUSTOMER: 'customer',
	ORDER_CIS: 'order_cis',
	TEST_OBS: 'test_obs',
	TEST_ORDER: 'test_order',
	RISPACS_ORDER: 'rispacs_order',
	SURGERY_ORDER: 'surgery_order',
	PHY_CLINICAL: 'phy_clinical',
	PHY_EXAM: 'phy_exam',
};

export const WfConstTrackerClinical = {
	ORDER_GROUP: 'order_group',
	MEDICAL_ITEMS: 'medical_items',
	APPOINTMENT: 'appointment',
};

export const WORKFLOW_FIELD_PROPERTY = {
	READONLY: 'R',
	WRITE: 'W',
	REQUIRED: 'Re',
	DISABLED: 'D',
	HIDDEN: 'H',
};

export const WORKFLOW_FIELD_PROPERTY_PROP_MAPPER = {
	[WORKFLOW_FIELD_PROPERTY.READONLY]: 'readOnly',
	[WORKFLOW_FIELD_PROPERTY.DISABLED]: 'disabled',
	[WORKFLOW_FIELD_PROPERTY.HIDDEN]: 'hidden',
  	[WORKFLOW_FIELD_PROPERTY.WRITE]: 'writable',
  	[WORKFLOW_FIELD_PROPERTY.REQUIRED]: 'required',
};

export const WORKFLOW_STATUS = {
	CHUA_LAY_MAU: 'sample_new',
	DA_LAY_MAU: 'sample_collected',
};

export const WORKFLOW_TYPE = {
	POPUP: 'popup',
	PRINT: 'print',
	BUTTON: 'button',
	FETCH: 'fetch',
	SERVICE_TASK: 'service_task', // BPMN 2.0: Process chạy ngầm tự động (background service)
};